import React from "react";

type Props = {
  Icon: React.ElementType;
  link: string;
};

const Icons = ({ Icon, link }: Props) => {
  return (
    <a
      target="_blank"
      href={link}
      rel="noreferrer noopener"
      hrefLang="en-us"
    >
      <Icon
        style={{
          background: "transparent",
          height: "20px",
          width: "20px",
          color: "white",
          cursor: "pointer",
        }}
      />
    </a>
  );
};

export default Icons;
